export function filterMatch(record, filter, defaultResult) {
    if (!filter) return defaultResult;
    let recordValue = record[filter.heading];
    if(recordValue === "") recordValue = null;
    if (filter.textToContain && recordValue) {
        return recordValue.includes(filter.textToContain);
    }

    return defaultResult;
}
